import React from 'react';
import { TbCards, TbDots, TbPhotoX } from 'react-icons/tb';
import { getIconMethodByType, MENU_PAY_ON_DELIVERY, MENU_PREPAID } from '../../Utils/Constants/Checkout';
import Img from './Img';
import { useTranslation } from 'react-i18next';
import ButtonLink from '../Form/ButtonLink';
import Badge from './Badge';

interface CardBoxCheckoutMethodProps {
    method?: any;
    loading:boolean;
    currentMenuMethod:number | null;
    onSelectMethod: CallableFunction;
}

const CardBoxCheckoutMethod = ({
    method,
    loading,
    currentMenuMethod,
    onSelectMethod = () => {}
}: CardBoxCheckoutMethodProps) => {

    const { t } = useTranslation();

    const getNameMenuMethod = (name: number) => {
        switch (name) {
            case MENU_PREPAID:
                return t('checkout.menu_methods.prepaid_label')
            case MENU_PAY_ON_DELIVERY:
                return t('checkout.menu_methods.pay_on_delivery_label')
            default:
                return null;
        }
    }

    return (
        loading
            ?
                <div className="flex items-center gap-2 w-full justify-between items-center rounded-lg animate-pulse min-h-14">
                    <div className={`bg-gray-200 max-w-5 max-h-5 min-w-5 min-h-5 rounded-full`}></div>
                    <div className='flex items-center gap-1.5 w-full justify-between'>
                        <div className='grid gap-1.5 w-full'>
                            <div className="flex flex-col w-1/4 bg-gray-200 h-3 rounded-md"></div>
                            <div className="flex flex-col w-1/2 bg-gray-200 h-3 rounded-md"></div>
                        </div>
                        <div className="flex flex-col w-1/4 bg-gray-200 h-3 rounded-md"></div>
                    </div>
                </div>
            :
                <div className="flex items-center gap-4 min-h-14">
                    <div className="w-full">
                        {!method
                            ?
                                <div className="flex gap-2 w-full justify-between items-center cursor-pointer" onClick={() => onSelectMethod()}>
                                    <div><TbCards size={25} /></div>
                                    <div className="grid gap-0.5 w-full">
                                        <span className='font-bold text-shopfood-title leading-none'>{t('cart.value_details.payment_methods')}</span>
                                        <span className='text-gray-400 leading-none text-sm'>{t('checkout.how_to_pay_title')}</span>
                                    </div>
                                </div>
                            :
                                <div className='flex items-center gap-2'>
                                    {!method.image_url && !method.brand_image && getIconMethodByType(method.type)}
                                    {(method.image_url || method.brand_image) &&
                                        <Img
                                            src={method.image_url || method.brand_image.toLowerCase()}
                                            alt={method.name}
                                            className="max-w-12 max-h-7"
                                            fallback={
                                            <div className='flex items-center justify-center bg-gray-200 max-w-7 min-w-7 max-h-7 min-h-7 rounded-full'>
                                                <TbPhotoX className='text-white' />
                                            </div>
                                            }
                                        />
                                    }
                                    <div className="grid gap-0.5">
                                        {currentMenuMethod && <span className="flex items-center text-sm leading-none justify-between text-gray-400">{getNameMenuMethod(currentMenuMethod)}</span>}
                                        <div className='flex items-center gap-2'>
                                            <div className="font-bold text-shopfood-title leading-none">
                                                {method.name || method.brand}
                                            </div>
                                            {Boolean(method.number || method.masked_number) &&
                                                <Badge className={`font-medium text-xs gap-0.5`}>
                                                    <TbDots /> { method?.number?.slice(-4) || method?.masked_number?.slice(-4) }
                                                </Badge>
                                            }
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                    <ButtonLink onClick={onSelectMethod} className="text-xs gap-0.5 text-xs h-8">
                        {!method ? t('layout.button_add_label') : t('layout.button_change_label') }
                    </ButtonLink>
                </div>
    )
}

    export default CardBoxCheckoutMethod;